// extracted by mini-css-extract-plugin
module.exports = {"comp":"SectionA4_comp___9n77"};